<!-- src/components/LatestRacesPanel.vue -->
<template>
  <section
    class="latest-panel"
    :style="{ '--label-w': labelWidth + 'px', '--cols': String(columns) }"
  >
    <!-- ヘッダー -->
    <header class="panel-head">
      <div class="head-left latest-race-title">
        <span>出走直前レース</span>
      </div>

      <div class="head-tabs">
        <button
          class="mode-btn scope"
          :class="mode==='scope' && 'is-active'"
          @click="$emit('update:mode','scope')"
          :aria-pressed="mode==='scope' ? 'true' : 'false'"
        >
          報知スコープ
        </button>
        <button
          class="mode-btn before"
          :class="mode==='before' && 'is-active'"
          @click="$emit('update:mode','before')"
          :aria-pressed="mode==='before' ? 'true' : 'false'"
        >
          直前データ
        </button>
      </div>
    </header>

    <!-- ボディ -->
    <div class="panel-body">
      <!-- 左の固定ラベル列 -->
      <div class="labels">
        <div class="label-cell">会場</div>
        <div class="label-cell">レース</div>
        <div class="label-cell">締切時間</div>
      </div>

      <!-- 横スクロール領域 -->
      <div class="viewport" ref="vp" @wheel.passive="onWheel">
        <div class="cols">
          <div v-for="(r, i) in normalized" :key="i" :class="['col', mode]">
            <div class="cell cell-rno" :class="mode">
              <router-link :to="linkTo(r)" class="cell-link">{{ r.joname }}</router-link>
            </div>
            <div class="cell">
              <router-link :to="linkTo(r)" class="cell-link">{{ r.rno }}R</router-link>
            </div>
            <div class="cell cell-time">
              <router-link :to="linkTo(r)" class="cell-link time-strong">{{ r.timeText }}</router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- ←→ 矢印（スクロール可能な時のみ表示） -->
      <button
        v-if="canL"
        class="chev chev-left"
        aria-label="前へ"
        @click="page(-1)"
      >‹</button>
      <button
        v-if="canR"
        class="chev chev-right"
        aria-label="次へ"
        @click="page(1)"
      >›</button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LatestRacesPanel',
  props: {
    items: { type: Array, default: () => [] },
    columns: { type: Number, default: 4 },       // ラベル除いた表示列数
    labelWidth: { type: Number, default: 160 },  // 左ラベル幅(px)
    mode: { type: String, default: 'before' }    // 'before' | 'scope'
  },
  data () {
    return {
      canL: false,
      canR: false
    }
  },
  computed: {
    normalized () {
      const nameMap = {
        '01':'桐　生','02':'戸　田','03':'江戸川','04':'平和島','05':'多摩川','06':'浜名湖',
        '07':'蒲　郡','08':'常　滑','09':'　津　','10':'三　国','11':'びわこ','12':'住之江',
        '13':'尼　崎','14':'鳴　門','15':'丸　亀','16':'児　島','17':'宮　島','18':'徳　山',
        '19':'下　関','20':'若　松','21':'芦　屋','22':'福　岡','23':'唐　津','24':'大　村'
      }
      let rows = (this.items || []).map(r => {
        const joid = String(r.jcd).padStart(2, '0')
        const time = r.stime
        const d = time ? new Date(time) : null
        const p = n => (n < 10 ? '0' + n : '' + n)
        return {
          ...r,
          joid,
          joname: nameMap[joid] || joid,
          racedate: (r.hdate || '').replace(/-/g, ''),
          timeText: d ? `${p(d.getHours())}:${p(d.getMinutes())}` : '—'
        }
      })
      // 直前予想モードの時は has_chokuzen_yosou が 1 のみ表示
      // if (this.mode === 'before') {
      //     rows = rows.filter(r => Number(r.has_chokuzen_yosou) > 0)
      // }
      // 
      return rows
    }
  },
  methods: {
    linkTo (r) {
      const name = this.mode === 'scope' ? 'HochiScope' : 'BeforeInfo'
      return { name, params: { date: r.racedate, jo: r.joid, race: r.rno } }
    },
    page (dir) {
      const el = this.$refs.vp
      if (!el) return
      el.scrollBy({ left: dir * el.clientWidth, behavior: 'smooth' })
      setTimeout(this.updateChev, 160)
    },
    onWheel (e) {
      const el = this.$refs.vp
      if (!el) return
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) el.scrollLeft += e.deltaY
    },
    updateChev () {
      const el = this.$refs.vp
      if (!el) return
      const { scrollLeft, clientWidth, scrollWidth } = el
      this.canL = scrollLeft > 1
      this.canR = scrollLeft + clientWidth < scrollWidth - 1
    }
  },
  mounted () {
    const el = this.$refs.vp
    if (el) el.addEventListener('scroll', this.updateChev, { passive: true })
    window.addEventListener('resize', this.updateChev)
    this.$nextTick(this.updateChev)
  },
  beforeDestroy () {
    const el = this.$refs.vp
    if (el) el.removeEventListener('scroll', this.updateChev)
    window.removeEventListener('resize', this.updateChev)
  },
  watch: {
    items: { handler () { this.$nextTick(this.updateChev) }, deep: true },
    columns () { this.$nextTick(this.updateChev) },
    mode () { this.$nextTick(this.updateChev) }
  }
}
</script>

<style scoped>
/* 変数:
   --label-w : 左ラベル幅
   --cols    : ラベル除いた表示列数
   --row-h   : 1 行の高さ */
.latest-panel{
  --label-w:160px;
  --cols:4;
  --row-h:60px;
  margin:40px 10px;
}

/* ヘッダー */
.panel-head{
  display:flex; align-items:center; justify-content:space-between;
  background:#0b2f4a; color:#fff; padding:10px 14px;
}
.head-left{ display:flex; align-items:center; gap:10px; font-weight:800; }
.head-tabs{ display:flex; gap:8px; }

.latest-race-title{
  padding-left:50px;
  padding-top:3px;
  padding-bottom:3px;
  background-image: url(/images/icon_boat_white.png);
  background-repeat: no-repeat;
  background-size: 45px;
  background-position:0 50%;

}
/* モードボタン：はっきり変化 */
.mode-btn{
  appearance:none; border:0; border-radius:10px; padding:12px 18px; font-weight:800;
  background:#e8eef5; color:#123a5c; cursor:pointer;
  transition:transform .06s ease, box-shadow .12s ease, background-color .12s ease, filter .12s ease;
  white-space: nowrap;
}
.mode-btn:hover{
  background:#dbe6f2; box-shadow:0 0 0 2px rgba(17,24,39,.15) inset;
}
.mode-btn:active{ transform:translateY(1px) scale(.99); }
.mode-btn.is-active{ background:#fff; color:#0b2f4a; box-shadow:0 0 0 2px #0b2f4a inset; }
.mode-btn.scope.is-active{ background:#317FC1; color:#fff; box-shadow:0 0 0 2px #246aa7 inset; }
.mode-btn.before.is-active{ background:#F86F03; color:#fff; box-shadow:0 0 0 2px #cc5902 inset; }

/* 本体 */
.panel-body{
  position:relative;
  display:flex; align-items:stretch;
  background:#fff; border:1px solid #e5e7eb; border-top:0; border-left:0;
  overflow:hidden;
}

/* 左ラベル列（固定） */
.labels{
  flex:0 0 var(--label-w);
  width:var(--label-w);
  background:#0b2f4a; color:#fff;
  display:grid; grid-auto-rows: var(--row-h);
}
.label-cell{
  display:flex; align-items:center; justify-content:center;
  font-weight:800; border-bottom:1px solid rgba(255,255,255,.15);
}

/* 右スクロール領域 */
.viewport{
  position:relative;
  flex:1 1 auto;
  width:calc(100% - var(--label-w));
  overflow:auto;
}

/* 中の列…常に --cols 列がジャスト表示 */
.cols{
  display:grid;
  grid-auto-flow: column;
  grid-auto-columns: calc(100% / var(--cols));
}
.col{
  display:grid;
  grid-template-rows: var(--row-h) var(--row-h) var(--row-h);
  border-left:1px solid #e5e7eb;
}
.col:first-child{ border-left:none; }

/* セル（左右 padding なし） */
.cell{
  display:flex; align-items:center; justify-content:center;
  padding:0; border-bottom:1px solid #e5e7eb; background:#fff;
}

/* 1 行目の帯（モード色） */
.cell-rno{ font-weight:700; font-size:16px; color:#0b2f4a; }
.cell-rno.before{ background:#F86F03; color:#fff; }
.cell-rno.scope{  background:#317FC1; color:#fff; }

.cell-link{
  width:100%; height:100%;
  display:flex; align-items:center; justify-content:center;
  text-decoration:none; color:inherit;
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
  transition: background-color .12s ease, box-shadow .12s ease, transform .06s ease, filter .12s ease;
  outline:0;
  cursor:pointer;
}

/* ホバーを強調（列全体のモード色で分かりやすく） */
.col.before .cell-link:hover{
  background: rgba(248,111,3,.16);
  box-shadow: inset 0 0 0 2px rgba(248,111,3,.45);
}
.col.scope .cell-link:hover{
  background: rgba(49,127,193,.18);
  box-shadow: inset 0 0 0 2px rgba(49,127,193,.45);
}
/* 1 行目はさらに強調 */
.cell-rno.before .cell-link:hover{ background:#ff8e48; }
.cell-rno.scope  .cell-link:hover{ background:#4c96d1; }

/* クリック時 */
.cell-link:active{ transform:translateY(1px) scale(.995); }

/* フォーカス可視化（キーボード操作） */
.cell-link:focus-visible{
  box-shadow: inset 0 0 0 3px #1aa3ff;
}

/* 矢印（出せるときだけ v-if） */
.chev{
  position:absolute; top:50%; transform:translateY(-50%);
  width:44px; height:44px; border-radius:50%;
  background:#fff; border:1px solid #e5e7eb; box-shadow:0 2px 8px rgba(0,0,0,.1);
  display:flex; align-items:center; justify-content:center; font-size:28px;
  color:#0b2f4a; cursor:pointer; z-index:5;
  transition: background-color .12s ease, color .12s ease, box-shadow .12s ease, transform .06s ease;
}
.chev-left { left: calc(var(--label-w) + 8px); }
.chev-right{ right: 8px; }

.chev:hover{
  background:#0b2f4a; color:#fff;
  box-shadow:0 4px 14px rgba(0,0,0,.22);
  transform:translateY(-50%) scale(1.06);
}
.chev:active{
  transform:translateY(-50%) scale(.98);
}

/* タッチ端末は矢印を隠す（保険） */
@media (hover: none){
  .chev{ display:none; }
}

/* モバイル：高さ揃え＆折り返し抑制 */
@media (max-width: 768px){
  .latest-panel{ margin:40px 0; --row-h:48px; }
  .labels{ grid-auto-rows: var(--row-h); }
  .col{ grid-template-rows: var(--row-h) var(--row-h) var(--row-h); }
  .cell-rno{ font-size:14px; }
  .cell .time-strong{ font-size:14px; }
}
@media screen and (max-width:375px) { 
  .latest-race-title{
    font-size:11px;

  }
}
</style>